<div id="stockNotificationContainer" class="flex-column" [ngClass]="notifications.length ? 'd-flex' : 'd-none'">
  @for (notification of notifications; track notification) {
    <app-stock-notification
      [notificationData]="notification"
      (closeNotification)="closeNotification(notification)"
    ></app-stock-notification>
  }
  @if (notifications.length && notifications[0].article_available) {
    <button class="btn btn-block btn-dark shadow" (click)="closeAll()">{{"CLOSE_ALL"|translate}}</button>
  }
</div>
